import './styles.scss'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'

import PostComment from '../PostComment'
import { lang } from 'utils/helpers'
import { toast } from 'react-toastify'
import { deleteManagerAPI } from 'api'

const PostReplies = ({
  level,
  reply,
  operator,
  labels,
  getTime,
  getCommentRepliesNodes,
  handleSaveLabels,
  saveLabelsRefreshCount
}) => {
  const [isVisibleReplies, setIsVisibleReplies] = useState(false)

  const repliesCount = reply.repliesCount || reply?.actionDetailList?.length || 0

  const handleDeleteComment = async (comment) => {
    try{
      await deleteManagerAPI.deleteComment({ userId: comment.user, messageId: comment._id })
    }catch(error){
      toast(lang('error_message_delete'), { position: 'top-right' })
    }
  }

  return (
    <div
      className='post-replies'
      style={{
        marginLeft: level > 1 ? '19px' : null,
        borderLeft: level > 1 ? '2px solid #EFECE9' : null
      }}
    >
      <PostComment
        id={reply._id}
        userId={reply.user}
        messageId={reply.messageId}
        operatorId={operator._id}
        type={reply.type}
        avatar={reply.postedBy?.photoURL}
        name={reply.postedBy?.name}
        profile={reply.postedBy?.profileURL}
        sentiment={reply.sentiment}
        sentimentList={reply.sentimentList}
        content={reply.messageContent}
        isRemoved={reply.isRemoved || false}
        reactions={reply.channel === 'instagram_post'
          ? reply.likeCount ? [{ totalCount: reply.likeCount, typeReaction: 'LOVE' }] : []
          : reply.reactionsFB || []
        }
        time={getTime(reply.createdAt || reply.updatedAt)}
        labels={labels}
        assignedLabels={reply.categories}
        channel={reply.channel}
        fatherBranch={reply.actionDetailList?.length > 0 && level <= 1 ? true : false}
        multipleBranch={level > 1 ? true : false}
        handleDeleteComment={()=>handleDeleteComment(reply)}
        handleSaveLabels={handleSaveLabels}
        saveLabelsRefreshCount={saveLabelsRefreshCount}
      />
      {reply.actionDetailList?.length > 0 && (
        isVisibleReplies ? (
          <div
            className='post-replies__replies-container animated fadeIn'
            style={{ marginLeft: level > 1 ? '28px' : null }}
          >
            {getCommentRepliesNodes({ level, replies: reply.actionDetailList }).map(reply => reply.node)}
          </div>
        ) : (
          <div
            className='post-replies__replies-btn-container'
            style={{ marginLeft: level > 1 ? '49px' : null }}
          >
            <button onClick={() => setIsVisibleReplies(true)}>
              <i className='fa fa-reply' aria-hidden='true'></i>
              <span>
                {`${repliesCount} ${repliesCount === 1 ? I18n.t('dashboard_answer') : I18n.t('dashboard_answers')}`}
              </span>
            </button>
          </div>
        )
      )}
    </div>
  )
}

export default PostReplies
